/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Sales
 * Это Sales api сервер, для запросов от Frontend.  Для запросов требуется указать header с Authorization и типом Bearer.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Category } from './Category'
import {
  CategoryFromJSON,
  CategoryFromJSONTyped,
  CategoryToJSON,
  CategoryToJSONTyped,
} from './Category'
import type { Supplier } from './Supplier'
import {
  SupplierFromJSON,
  SupplierFromJSONTyped,
  SupplierToJSON,
  SupplierToJSONTyped,
} from './Supplier'
import type { Image } from './Image'
import {
  ImageFromJSON,
  ImageFromJSONTyped,
  ImageToJSON,
  ImageToJSONTyped,
} from './Image'
import type { ItemAttribute } from './ItemAttribute'
import {
  ItemAttributeFromJSON,
  ItemAttributeFromJSONTyped,
  ItemAttributeToJSON,
  ItemAttributeToJSONTyped,
} from './ItemAttribute'

/**
 *
 * @export
 * @interface Item
 */
export interface Item {
  /**
   *
   * @type {string}
   * @memberof Item
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof Item
   */
  externalId?: string
  /**
   *
   * @type {string}
   * @memberof Item
   */
  barcode: string
  /**
   *
   * @type {string}
   * @memberof Item
   */
  title: string
  /**
   *
   * @type {string}
   * @memberof Item
   */
  count: string
  /**
   *
   * @type {string}
   * @memberof Item
   */
  typeOfCount: ItemTypeOfCountEnum
  /**
   *
   * @type {string}
   * @memberof Item
   */
  discount: string
  /**
   *
   * @type {string}
   * @memberof Item
   */
  priceBuy: string
  /**
   *
   * @type {string}
   * @memberof Item
   */
  priceOut: string
  /**
   *
   * @type {string}
   * @memberof Item
   */
  priceDiscount: string
  /**
   *
   * @type {string}
   * @memberof Item
   */
  shopId: string
  /**
   *
   * @type {string}
   * @memberof Item
   */
  categoryId?: string
  /**
   *
   * @type {string}
   * @memberof Item
   */
  imageId?: string
  /**
   *
   * @type {number}
   * @memberof Item
   */
  createdAt: number
  /**
   *
   * @type {number}
   * @memberof Item
   */
  updatedAt: number
  /**
   *
   * @type {Category}
   * @memberof Item
   */
  category?: Category
  /**
   *
   * @type {Image}
   * @memberof Item
   */
  image?: Image
  /**
   *
   * @type {Array<ItemAttribute>}
   * @memberof Item
   */
  attributes?: Array<ItemAttribute>
  /**
   *
   * @type {string}
   * @memberof Item
   */
  supplierId?: string
  /**
   *
   * @type {Supplier}
   * @memberof Item
   */
  supplier?: Supplier
}

/**
 * @export
 */
export const ItemTypeOfCountEnum = {
  Weight: 'WEIGHT',
  Count: 'COUNT',
} as const
export type ItemTypeOfCountEnum =
  (typeof ItemTypeOfCountEnum)[keyof typeof ItemTypeOfCountEnum]

/**
 * Check if a given object implements the Item interface.
 */
export function instanceOfItem(value: object): value is Item {
  if (!('id' in value) || value['id'] === undefined) return false
  if (!('barcode' in value) || value['barcode'] === undefined) return false
  if (!('title' in value) || value['title'] === undefined) return false
  if (!('count' in value) || value['count'] === undefined) return false
  if (!('typeOfCount' in value) || value['typeOfCount'] === undefined)
    return false
  if (!('discount' in value) || value['discount'] === undefined) return false
  if (!('priceBuy' in value) || value['priceBuy'] === undefined) return false
  if (!('priceOut' in value) || value['priceOut'] === undefined) return false
  if (!('priceDiscount' in value) || value['priceDiscount'] === undefined)
    return false
  if (!('shopId' in value) || value['shopId'] === undefined) return false
  if (!('createdAt' in value) || value['createdAt'] === undefined) return false
  if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false
  return true
}

export function ItemFromJSON(json: any): Item {
  return ItemFromJSONTyped(json, false)
}

export function ItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Item {
  if (json == null) {
    return json
  }
  return {
    id: json['id'],
    externalId: json['externalId'] == null ? undefined : json['externalId'],
    barcode: json['barcode'],
    title: json['title'],
    count: json['count'],
    typeOfCount: json['typeOfCount'],
    discount: json['discount'],
    priceBuy: json['priceBuy'],
    priceOut: json['priceOut'],
    priceDiscount: json['priceDiscount'],
    shopId: json['shopId'],
    categoryId: json['categoryId'] == null ? undefined : json['categoryId'],
    imageId: json['imageId'] == null ? undefined : json['imageId'],
    createdAt: json['createdAt'],
    updatedAt: json['updatedAt'],
    category:
      json['category'] == null ? undefined : CategoryFromJSON(json['category']),
    image: json['image'] == null ? undefined : ImageFromJSON(json['image']),
    attributes:
      json['attributes'] == null
        ? undefined
        : (json['attributes'] as Array<any>).map(ItemAttributeFromJSON),
    supplierId: json['supplierId'] == null ? undefined : json['supplierId'],
    supplier:
      json['supplier'] == null ? undefined : SupplierFromJSON(json['supplier']),
  }
}

export function ItemToJSON(json: any): Item {
  return ItemToJSONTyped(json, false)
}

export function ItemToJSONTyped(
  value?: Item | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value
  }

  return {
    id: value['id'],
    externalId: value['externalId'],
    barcode: value['barcode'],
    title: value['title'],
    count: value['count'],
    typeOfCount: value['typeOfCount'],
    discount: value['discount'],
    priceBuy: value['priceBuy'],
    priceOut: value['priceOut'],
    priceDiscount: value['priceDiscount'],
    shopId: value['shopId'],
    categoryId: value['categoryId'],
    imageId: value['imageId'],
    createdAt: value['createdAt'],
    updatedAt: value['updatedAt'],
    category: CategoryToJSON(value['category']),
    image: ImageToJSON(value['image']),
    attributes:
      value['attributes'] == null
        ? undefined
        : (value['attributes'] as Array<any>).map(ItemAttributeToJSON),
    supplierId: value['supplierId'],
    supplier: SupplierToJSON(value['supplier']),
  }
}
